import { Component } from '@angular/core';

@Component({
  selector: 'kui-dropdown-button',
  templateUrl: './dropdown-button.component.html',
})
export class KuiDropdownButtonComponent { }


